import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  containerDark: {
    backgroundColor: theme.colors.card_background_secondary,
    padding: theme.spacing(8, 6),
    borderRadius: theme.sizes.roundCorners
  },
  table: {
    '& td, th': {
      borderBottom: 'none',
      padding: theme.spacing(4),
      whiteSpace: 'nowrap'
    },
    '& td:last-child': {
      paddingRight: theme.spacing(7)
    },
    '& tr': {
      borderBottom: `1px solid ${theme.colorPalette.white_30_op_30}`
    }
  },
  columnLabel: {
    color: theme.colors.light_text,
    opacity: 0.6
  }
});

export default makeStyles(styles);
